module.exports = __webpack_public_path__ + "static/media/alert-circle-info.c105ace0.svg";